import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { Link, createRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { routeTree } from "./routeTree.gen";

function NotFoundComponent() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen w-full">
      <main className="flex-1 relative w-full h-screen overflow-hidden">
        <div className="h-full flex items-center justify-center px-44">
          <Alert>
            <AlertTitle>{`404 | ${t("http_errors.not_found.label")}!`}</AlertTitle>
            <AlertDescription>
              {t("http_errors.not_found.description")}
            </AlertDescription>
            <Link to="/" className="flex items-center gap-2 mt-2">
              <ArrowLeftIcon className="w-4 h-4" />
              {t("http_errors.back_to_home")}
            </Link>
          </Alert>
        </div>
      </main>
    </div>
  );
}

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
  defaultNotFoundComponent: NotFoundComponent,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
